'use client';

import { ReactNode, useState } from 'react';
import { CreateDeveloperForm } from './create-developer-form';
import { Login } from './login-form';
import { Agent, AgentCtx } from '../agent';

export default function Developer(): ReactNode {
  const [agent, setAgent] = useState<Agent | undefined>(undefined);

  if (!agent) return <Login onLogin={setAgent} />;

  return (
    <AgentCtx value={agent}>
      <CreateDeveloperForm />
    </AgentCtx>
  );
}
